export function fromLatLngLiteralToLatLngTuple({
  lat,
  lng,
}: L.LatLngLiteral): L.LatLngTuple {
  return [lat, lng]
}

export function fromLatLngTupleToLatLngLiteral([
  lat,
  lng,
]: L.LatLngTuple): L.LatLngLiteral {
  return { lat, lng }
}
